import { NgModule }       from '@angular/core';
import { AnswersService } from './answers.service';

@NgModule({
  providers: [AnswersService]
})
export class AnswerModule { }
